import "@fontsource/noto-sans-jp/400.css";
import "@fontsource/noto-sans-jp/500.css";
import "@fontsource/noto-sans-jp/700.css";
import "./styles/mantine.css";
import "./styles/globals.css";

import { RouterProvider } from "@tanstack/react-router";
import React from "react";
import ReactDOM from "react-dom/client";

import { AppProviders } from "./app/providers";
import { ErrorBoundary } from "./components/feedback/error-boundary";
import { ErrorFallback } from "./components/feedback/error-fallback";
import { env } from "./lib/env";
import { router } from "./lib/router";

async function enableMocking(): Promise<void> {
  if (!env.useMockApi) return;
  const { worker } = await import("./mocks/browser");
  await worker.start({
    onUnhandledRequest(req, print) {
      const url = new URL(req.url);
      if (url.pathname.startsWith("/api/")) {
        print.warning();
      }
    },
    serviceWorker: { url: "/mockServiceWorker.js" },
  });
  console.warn(
    "[MSW] Mock API enabled (VITE_USE_MOCK_API=true). For real API, set VITE_USE_MOCK_API=false.",
  );
}

void enableMocking().then(() => {
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <ErrorBoundary
        fallback={(error, reset) => (
          <ErrorFallback error={error} onReset={reset} variant="page" />
        )}
      >
        <AppProviders>
          <RouterProvider router={router} />
        </AppProviders>
      </ErrorBoundary>
    </React.StrictMode>,
  );
});
